export default {
	postSaleCTA: {
		book: 'Book',
		delivery: { desktop: '{action} delivery {details}', mobile: '{action} delivery' },
		details: 'details',
		sellerDetails: { desktop: "View seller's details", mobile: "Seller's details" },
		view: 'View',
	},
	soldDate: 'Sold date',
};
